module.exports = __webpack_public_path__ + "static/media/like.3ce4683f.mp3";